export const STALE_TIME = 1000;
